import { emptyUser, IUserDetail } from 'src/context/ute-auth-context/auth-provider-types';
import { OTPValidationStatus } from 'src/modules/common/common-types';

interface IAUDetails {
	emailAddress: string;
	name: string;
	primaryEmailAddress: string;
	registrationId: number;
	taxPayerAssociatesId: number;
}

export interface IValidOTPDetail {
	accessToken: string;
	refreshToken: string;
	data: IUserDetail;
	isSuccess: boolean;
	status: OTPValidationStatus;
}

export interface IValidateOTPResponse {
	validOTPDetail: IValidOTPDetail;
	error: boolean;
}

export const initialValidOTPDetail: IValidOTPDetail = {
	accessToken: '',
	refreshToken: '',
	data: emptyUser,
	isSuccess: false,
	status: OTPValidationStatus.Success,
};
